import { Command } from '@ckeditor/ckeditor5-core';
export default class InsertComparisonCommand extends Command {
    execute() {
        this.editor.model.change((writer) => {
            this.editor.model.insertContent(createDoDont(writer));
        });
    }
    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const firstPosition = selection.getFirstPosition();
        const allowedIn = firstPosition && model.schema.findAllowedParent(firstPosition, 'comparison');
        this.isEnabled = allowedIn !== null;
    }
}
function createDoDont(writer) {
    const comparison = writer.createElement('comparison');
    const comparisonCorrect = writer.createElement('comparisonCorrect');
    const comparisonIncorrect = writer.createElement('comparisonIncorrect');
    writer.append(comparisonCorrect, comparison);
    writer.append(comparisonIncorrect, comparison);
    writer.appendElement('paragraph', comparisonCorrect);
    writer.appendElement('paragraph', comparisonIncorrect);
    return comparison;
}
